import PropTypes from 'prop-types';
import React from 'react';

import {
    EMPTY_STATE_IMAGES,
    NETWORK_CARD_TYPE,
} from '../../../pages/MyNetwork/sharedConstants';
import { buildImagePath } from '../../Content/User/UserDisplay/UserImage/UserImage';

import './EmptyStates.scss';

export default class EmptyStates extends React.PureComponent {
    static propTypes = {
        /**
         * string of detail to be rendered on card
         */
        detail: PropTypes.string,
        /**
         * string of networkCardType for sending back image
         */
        networkCardType: PropTypes.string,
        /**
         * boolean for showing empty state icon on main dashboard
         */
        shouldShowImage: PropTypes.bool,
    };

    static defaultProps = {
        detail: '',
        networkCardType: null,
        shouldShowImage: true,
    };

    renderEmptyState = () => {
        const {
            CONNECTED_USERS,
            JOINED_GROUPS,
            INVITED_USERS,
            FOLLOWED_USERS,
            PENDING_REQUESTS,
            PENDING_GROUP_REQUESTS,
            RECOMMENDED_USERS,
            RECOMMENDED_GROUPS,
        } = NETWORK_CARD_TYPE;

        switch (this.props.networkCardType) {
            case CONNECTED_USERS:
                return EMPTY_STATE_IMAGES.CONNECTED_USERS;
            case JOINED_GROUPS:
                return EMPTY_STATE_IMAGES.JOINED_GROUPS;
            case INVITED_USERS:
                return EMPTY_STATE_IMAGES.INVITED_USERS;
            case FOLLOWED_USERS:
                return EMPTY_STATE_IMAGES.FOLLOWED_USERS;
            case PENDING_REQUESTS:
            case PENDING_GROUP_REQUESTS:
            case RECOMMENDED_USERS:
            case RECOMMENDED_GROUPS:
            default:
                return null;
        }
    };

    render() {
        const { shouldShowImage } = this.props;
        const emptyStateImage = this.renderEmptyState();
        return (
            <div className="component-Network-EmptyStates">
                {shouldShowImage && emptyStateImage && (
                    <img src={buildImagePath(emptyStateImage, 'medium')} />
                )}
                <div className="empty-state-info">{this.props.detail}</div>
            </div>
        );
    }
}
